// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"1527e26a","279":"83ad9968","365":"c2b2a456","582":"b9bc745a","667":"9af58127","695":"a70227ad","744":"8ea95abf","780":"9370349d"}[chunkId] + ".chunk.js";
};